import { publicClient, privateClient } from './client';
import { AssignedCoupon } from './AssignedCoupon';

const transactionsAssignedCoupon = (pub: boolean) => new AssignedCoupon(pub ? publicClient : privateClient);
export default transactionsAssignedCoupon;
